﻿const main = {
  install(vue: any, parameters: any) {
    const REGISTER_MENU = getRegisterMenu()
    parameters.registerMenu(REGISTER_MENU, parameters);
  }
}


export default main

const getRegisterMenu = () => ({
  id: 'benefitsClub',
  title: 'Clube godrive',
  icon: 'fa-solid fa-gift',
  order: 5,
  groupNameKey: 'benefitsClub',
  route: '/benefitsClub/embed',
  items: [
    {
      id: 'embed',
      icon: 'fa-solid fa-external-link-alt',
      components: [
        {
          path: () => import('./embed-benefits-club.vue'),
        },
      ]
    }
  ],
})
